module.exports = __webpack_public_path__ + "static/paris-009-117a3937e85e932b3f9ff92a1a224dfb.jpg";